/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { useRouter } from 'next/router'
import { Grid, Checkbox, Box, Typography } from '@mui/material'
import { useFormik } from 'formik'
import { useLoginMutation } from 'src/store/ApiCall/authApiCalls'
import { useSnackbar } from 'notistack'
import RoundedTextField from 'src/components/shared/atoms/roundInputField_v3'
import PasswordInputField from 'src/components/shared/atoms/passwordInput'
import * as yup from 'yup'
import { ButtonComponent } from 'src/components/shared/atoms'
import useStyles from './styles'
import { getCookie, setCookie } from 'cookies-next'

interface TokenType {
  username: string
  topics: boolean
}

const LoginForm: React.FC = () => {
  const [topicsUser, setTopicsUser] = React.useState(false)
  const router = useRouter()

  const [login] = useLoginMutation()
  const { enqueueSnackbar } = useSnackbar()
  const lang = getCookie('lang')

  const validationSchema = yup.object({
    username: yup
      .string()
      .required(
        lang === 'En' ? 'Username is required' : 'Se requiere nombre de usuario'
      ),
    password: yup
      .string()
      .required(
        lang === 'En' ? 'Password is required' : 'se requiere contraseña'
      ),
    keepMeSignIn: yup.boolean(),
  })
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      keepMeSignIn: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!values.username || !values.username) {
        enqueueSnackbar(
          lang === 'En'
            ? 'Please add username and password'
            : 'Por favor agregue nombre de usuario y contraseña',
          {
            variant: 'error',
          }
        )
        return
      }

      // TODO: update res type(also from store rtk res type)
      const res: any = await login({
        username: values.username,
        password: values.password,
      })

      if (res?.data) {
        localStorage.setItem(
          'dtl_token',
          JSON.stringify({
            id: res.data.id,
            username: res.data.username,
            avatar: res.data.avatar ? res.data.avatar.url : '',
          })
        )
        setCookie(
          'dtl_token',
          JSON.stringify({
            id: res.data.id,
            username: res.data.username,
            avatar: res.data.avatar ? res.data.avatar.url : '',
          })
        )
        return router.push('/')
      } else {
        if (res.error.data.error && typeof res.error.data.error == 'string') {
          return errorHandler(res.error.data.error)
        }
        return errorHandler(
          lang === 'En'
            ? 'Error signing in, please try again!'
            : '¡Error al iniciar sesión, inténtalo de nuevo!'
        )
      }
    },
  })

  const errorHandler = (error: string) => {
    formik.errors.username = ' '
    formik.touched.username = true
    formik.errors.password = error || ' '
    formik.touched.password = true
  }

  // ? check local storage token for re-routing and topics selection popup
  React.useEffect(() => {
    const dtlToken: string | null =
      typeof window === 'object' ? localStorage.getItem('dtl_token') : null
    if (dtlToken) {
      const token: TokenType = JSON.parse(dtlToken)
      setTopicsUser(token.topics)

      // ? check if username exist
      if (!token.username) return

      if (topicsUser) {
        router.push('/')
        return
      }
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { classes } = useStyles()
  return (
    <>
      <Grid container className={classes.root}>
        <Box component="div" className={classes.headingContainer}>
          <Typography variant="h2" className={classes.title}>
            {lang === 'En' ? 'Login' : 'INGRESAR'}
          </Typography>
        </Box>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <RoundedTextField
            label={lang === 'En' ? 'Username' : 'Nombre de usuario'}
            placeHolder={lang === 'En' ? 'Johndoe1' : 'Johndoe1'}
            id="username"
            name="username"
            value={formik.values.username}
            onChangeHandler={(e: React.ChangeEvent<any>) =>
              formik.handleChange(e)
            }
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={formik.touched.username && formik.errors.username}
          />
          <PasswordInputField
            label={lang === 'En' ? 'Password' : 'Contraseña'}
            placeHolder={lang === 'En' ? 'Password' : 'Contraseña'}
            id="password"
            name="password"
            type="password"
            value={formik.values.password}
            onChangeHandler={(e: React.ChangeEvent<any>) =>
              formik.handleChange(e)
            }
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <Box component="div" className={classes.checkboxContainer}>
            <Checkbox
              inputProps={{ 'aria-label': 'Send me news and updates' }}
              id="sendMeUpdates"
              name="sendMeUpdates"
              value={formik.values.keepMeSignIn}
              onChange={formik.handleChange}
            />
            <Typography variant="body2" className={classes.checkboxLabel}>
              {lang === 'En' ? 'Keep me sign in ' : 'Mantenerme conectado'}
            </Typography>
          </Box>

          <ButtonComponent
            type="text"
            text={lang === 'En' ? 'Login' : 'Ingresar'}
            className={classes.loginBtn}
            gradient
            wrapperClass={classes.btnWrapper}
            isSubmitBtn
          />
        </form>
      </Grid>
    </>
  )
}

export default LoginForm
